// extracted by mini-css-extract-plugin
export default {"socials_wrapper":"SocialIcons_socials_wrapper__XmUHi","icon":"SocialIcons_icon__q1sv3"};